import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSummary } from "../services/solevaniaService";
import { toast } from "react-toastify";

export const useDeleteSummary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSummary,
    onSuccess: () => {
      toast.success("Povzetek uspešno izbrisan.");
      queryClient.invalidateQueries(["summaries"]);
    },
    onError: (error) => {
      toast.error(`Napaka pri brisanju povzetka`);
    },
  });
};
